import React from 'react';
import Modal from '../../BaseComponents/Modal';
import Button from '../../BaseComponents/Button';
import './InuviBookingModal.scss';

interface InuviBookingData {
  member_id: string;
  appointment_id: number;
  exams_id: string;
  order_id: string;
  is_booked: boolean;
  created_at: string;
}

interface InuviBookingModalProps {
  isOpen: boolean;
  onClose: () => void;
  bookingData: InuviBookingData | null;
}

const InuviBookingModal: React.FC<InuviBookingModalProps> = ({
  isOpen,
  onClose,
  bookingData
}) => {
  if (!bookingData) return null;

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      title="Inuvi Booking Information"
      width="500px"
    >
      <div className="inuvi-booking-modal">
        <div className="modal-content">
          
          <div className="info-row">
            <label>Exams ID:</label>
            <span>{bookingData.exams_id}</span>
          </div>
          
          <div className="info-row">
            <label>Order ID:</label>
            <span>{bookingData.order_id}</span>
          </div>
          
          <div className="info-row">
            <label>Booking Status:</label>
            <span className={`status ${bookingData.is_booked ? 'booked' : 'not-booked'}`}>
              {bookingData.is_booked ? 'Booked' : 'Not Booked'}
            </span>
          </div>
          
          <div className="info-row">
            <label>Created At:</label>
            <span>{formatDate(bookingData.created_at)}</span>
          </div>
        </div>
        
        <div className="modal-footer">
          <Button text="Close" onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
};

export default InuviBookingModal;
